<template>
    <div class="container-fluid">
        <div class="img">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="transparent-block">
                            <span class="header">
                                <h1>What we think, we become</h1>
                            </span>
                            <div class="subheader">
                                <i>-Bhudda-</i>
                            </div>
                            <div class="header-button">
                                <router-link to="/labels" class="btn">{{ $t('menu.labels') }}</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="bottom-bar row d-none d-md-flex">
            <div class="col-0 col-md-6 col-lg-3">
                <div class="row">
                    <div class="col-3 principle">
                        <span class="icon icon-handshake-o"></span>
                    </div>
                    <div class="col-9 principle">
                        <div class="mb-2">
                            <b>{{ $t('home.collaboration') }}</b>
                        </div>
                        <span>{{ $t('home.collaboration_expl') }}</span>
                    </div>
                </div>
            </div>
            <div class="col-0 col-md-6 col-lg-3">
                <div class="row px-3">
                    <div class="col-3 principle">
                        <span class="icon icon-rocket"></span>
                    </div>
                    <div class="col-9 principle">
                        <div class="mb-2">
                            <b>{{ $t('home.growth') }}</b>
                        </div>
                        <span>{{ $t('home.growth_expl') }}</span>
                    </div>
                </div>
            </div>
            <div class="col-0 col-md-6 col-lg-3">
                <div class="row px-3">
                    <div class="col-3 principle">
                        <span class="icon icon-display"></span>
                    </div>
                    <div class="col-9 principle">
                        <div class="mb-2">
                            <b>{{ $t('home.it') }}</b>
                        </div>
                        <span>
                            {{ $t('home.it_expl') }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-0 col-md-6 col-lg-3">
                <div class="row px-3">
                    <div class="col-3 principle">
                        <span class="icon icon-bubbles4"></span>
                    </div>
                    <div class="col-9 principle">
                        <div class="mb-2">
                            <b>{{ $t('home.advice') }}</b>
                        </div>
                        <span>{{ $t('home.advice_expl') }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="bottom-bar d-flex d-md-none">
            <carousel :autoplay="2000" :wrap-around="true">
                <slide :key="1"> 
                    <div class="row px-3">
                        <div class="col-3 principle">
                            <span class="icon icon-handshake-o"></span>
                        </div>
                        <div class="col-9 principle">
                            <div class="mb-2">
                                <b>{{ $t('home.collaboration') }}</b>
                            </div>
                            <span>{{ $t('home.collaboration_expl') }}</span>
                        </div>
                    </div>
                </slide>
                <slide :key="2">
                    <div class="row px-3">
                        <div class="col-3 principle">
                            <span class="icon icon-rocket"></span>
                        </div>
                        <div class="col-9 principle">
                            <div class="mb-2">
                                <b>{{ $t('home.growth') }}</b>
                            </div>
                            <span>{{ $t('home.growth_expl') }}</span>
                        </div>
                    </div>
                </slide>
                <slide :key="3">
                    <div class="row px-3">
                        <div class="col-3 principle">
                            <span class="icon icon-display"></span>
                        </div>
                        <div class="col-9 principle">
                            <div class="mb-2">
                                <b>{{ $t('home.it') }}</b>
                            </div>
                            <span>
                                {{ $t('home.it_expl') }}
                            </span>
                        </div>
                    </div>
                </slide>
                <slide :key="4">
                    <div class="row px-3">
                        <div class="col-3 principle">
                            <span class="icon icon-bubbles4"></span>
                        </div>
                        <div class="col-9 principle">
                            <div class="mb-2">
                                <b>{{ $t('home.advice') }}</b>
                            </div>
                            <span>{{ $t('home.advice_expl') }}</span>
                        </div>
                    </div>
                </slide>
                <template #addons>
                </template>
            </carousel>
        </div>
    </div>
</template>

<script>
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide } from 'vue3-carousel'
export default {
    name: 'HomeHeaderComponent',
    components: {
        Carousel,
        Slide
    }
}
</script>

<style>
.carousel {
    width: 100%
}

.carousel__next,
.carousel__prev
 {
    color: white;
}
</style>